export const CheckmarkIcon3 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="167"
    height="162"
    viewBox="79 80 22 16"
    fill="none"
    overflow="visible"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g filter="url(#nf-checkmark-icon3-drop-shadow)">
      <path
        d="M86.9113 92.7751L82.9175 88.7402C82.7025 88.5225 82.4105 88.4001 82.1061 88.4001C81.8016 88.4001 81.5097 88.5225 81.2947 88.7402C80.8458 89.1937 80.8458 89.9263 81.2947 90.3798L86.1057 95.2402C86.5545 95.6937 87.2796 95.6937 87.7285 95.2402L99.9056 82.9379C100.354 82.4844 100.354 81.7519 99.9056 81.2984C99.6906 81.0806 99.3986 80.9583 99.0942 80.9583C98.7897 80.9583 98.4978 81.0806 98.2828 81.2984L86.9113 92.7751Z"
        fill="currentColor"
      />
      <path
        d="M86.9113 92.7751L82.9175 88.7402C82.7025 88.5225 82.4105 88.4001 82.1061 88.4001C81.8016 88.4001 81.5097 88.5225 81.2947 88.7402C80.8458 89.1937 80.8458 89.9263 81.2947 90.3798L86.1057 95.2402C86.5545 95.6937 87.2796 95.6937 87.7285 95.2402L99.9056 82.9379C100.354 82.4844 100.354 81.7519 99.9056 81.2984C99.6906 81.0806 99.3986 80.9583 99.0942 80.9583C98.7897 80.9583 98.4978 81.0806 98.2828 81.2984L86.9113 92.7751Z"
        stroke="currentColor"
        strokeWidth="1.06873"
      />
    </g>
    <defs>
      <filter
        id="nf-checkmark-icon3-drop-shadow"
        x="-8.29697e-05"
        y="8.58307e-06"
        width="166.353"
        height="161.691"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="7.42391" dy="7.42391" />
        <feGaussianBlur stdDeviation="11.1359" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4400_988" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-7.42391" dy="-7.42391" />
        <feGaussianBlur stdDeviation="36.5" />
        <feColorMatrix type="matrix" values="0.35 0 0 0 0 0 0.35 0 0 0 0 0 0.35 0 0 0 0 0 1 0" />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_4400_988"
          result="effect2_dropShadow_4400_988"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="4.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0.6 0 0 0 0 0 0.6 0 0 0 0 0 0.6 0 0 0 0 0 0.25 0" />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_4400_988"
          result="effect3_dropShadow_4400_988"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_4400_988"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
